import { AbstractControl } from '@angular/forms';

export function PostalCodeValidator(control: AbstractControl) {

  let postalCode = control.value;

  if (postalCode === null || postalCode === undefined || postalCode.length === 0) {
    // if postal code is not present, dont send error, use Validators.requiredNotBlank
    return null;
  }

  postalCode = postalCode.replace(/\-/g, '');
  if (postalCode.length === 5) {
    let number = parseInt(postalCode);

    if (!isNaN(number) && number === 0) {
      return { postalCodeValid: true };
    }
  }
  // FIXME if we get new actual postal codes database
  // if (postalCodes.includes(postalCode)) {
  //   return true;
  // } else {
  //   return { existingPostalCode: true };
  // }
}
